export interface ComplexSuggestedItem {
  label: string;
  value: string;
  type?: number;
  icon?: string;
  isEllipsis?: boolean;
}

export interface ComplexPinnedListItem {
  label: string;
  value: string;
  icon?: string;
  type?: number;
  checked: boolean;
}

export interface ErrorMessageDetails {
  message: string;
}

export enum ComplexEnumListEvents {
  COMPLEX_SEARCH_CHANGE = 'complexSearchChange',
  COMPLEX_OPTIONS_FILTERED = 'complexOptionsFiltered',
  COMPLEX_OPTION_CHANGED = 'complexOptionChanged',
  COMPLEX_SELECTION_CHANGE = 'complexSelectionChange',
  COMPLEX_LOAD_MORE = 'complexLoadMore',
}
